
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppCard, AppButton, AppSelect, AppInput } from '@/components';
import { useItemEdit } from '@/modules/item/system/model/link';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';

export default defineComponent({
    name: ROUTE_NAME_ITEM.SYSTEM.LINK,
    components: { AppFormRow, AppCard, AppButton, AppSelect, AppInput },
    setup() {
        const { model, actions, beforeFetch, fetch } = useItemEdit();

        onMounted(() => {
            beforeFetch();
        });

        return { model, actions, fetch };
    }
});
